import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { UserService } from '../../../../services/user/user.service';
import { GamesLauncherService } from '../../../../services/games/games-launcher.service';
import { GoogleTagManagerService } from '../../../../services/google-tag-manager.service';
import { GroupsService, UserGroup } from '../../../../services/groups.service';
import { RouterLink } from '@angular/router';
import { MotivateWithdrawalService } from '../../../../services/motivate-withdrawal.service';
import { BreakpointsDetectorService } from '../../../../services/breakpoints-detector.service';
import { WebSocketService } from '../../../../services/web-socket.service';
import { map } from 'rxjs/operators';
import { TranslatePipe } from '../../../translation/translate.pipe';
import { CurrencyFormatPipe } from '../../../pipes/currency-format.pipe';
import { SetImgAltDirective } from '../../../directives/set-img-alt.directive';
import { RouterLinkDirective } from '../../../directives/router-link.directive';
import { CurrencyService } from '../../../../services/currency.service';
import { toSafeSignal } from 'ngx-unificator/helpers';

@Component({
    selector: 'app-header-balance',
    templateUrl: './header-balance.component.html',
    styleUrls: ['./header-balance.component.scss'],
    imports: [RouterLink, RouterLinkDirective, SetImgAltDirective, CurrencyFormatPipe, TranslatePipe]
})
export class HeaderBalanceComponent implements OnInit {
  user = inject(UserService);
  launcher = inject(GamesLauncherService);
  groups = inject(GroupsService);
  motivateWithdrawal = inject(MotivateWithdrawalService);
  breakpoints = inject(BreakpointsDetectorService);
  private _gtm = inject(GoogleTagManagerService);
  private _ws = inject(WebSocketService);
  private _currency = inject(CurrencyService);


  baseImg = '/assets/img/user/';
  userImg = signal<string>('');

  public balance$ = this._ws.userBalance$.pipe(
    map(balance => {
      return {
        ...balance,
        amount: this._currency.subunitsToUnits(balance.amount_cents, balance.currency),
      };
    }),
  );

  balanceSignal = toSafeSignal(this.balance$, { initialValue: null as { amount:number; currency:string } | null });

  balanceValueSignal = computed(() => {
    const b = this.balanceSignal();
    const u = this.user.currentCurrency;

    const code = u?.currency ?? b?.currency ?? '';
    return {
      leftToken: u?.currency ?? b?.currency ?? '',
      amount:    b?.amount ?? u?.amount ?? 0,
      code
    };
  });

  ngOnInit() {
    this.checkIconImg();
  }

  checkIconImg() {
    if (this.groups.loyaltyGroup === UserGroup.NINJA) {
      this.userImg.set(`${this.baseImg}user-ninja-redesign.png`);
    } else if (this.groups.loyaltyGroup === UserGroup.SAMURAI) {
      this.userImg.set(`${this.baseImg}user-samurai-redesign.png`);
    }
  }

  onDepositClick(isDepositClick = true) {
    if (isDepositClick) {
      this._gtm.depositHeaderButton('deposit_header', 'header', this.user.info.id);
    }
  }

}
